<p-card>
  <ng-template pTemplate="header">
    <div class="title-visualizacao"><span class="cl-blue">Cep: </span>
      <span>{{cep.numero}}</span>
    </div>
  </ng-template>
  <div class="p-fluid">
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Id:</label>
      <div class="p-col-12 p-md-10">{{cep.id}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Logradouro: </label>
      <div class="p-col-12 p-md-10">{{cep.logradouro}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Bairro: </label>
      <div class="p-col-12 p-md-10">{{cep.bairro}}</div>
    </div>
    <div class="p-field p-grid">
      <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0 p-text-bold">Cidade: </label>
      <div class="p-col-12 p-md-10">
            <span *ngIf="cep.localidade.id != null">
              <a [routerLink]="['/localidade/visualizar/', cep.localidade.id]"  title="Visualizar Localidade">{{cep.localidade.nome}}</a>
            </span>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="p-col-12">
      <button pButton appBotaoVoltar class="p-button-primary  p-lg-12" label="Voltar"></button>
    </div>
  </ng-template>
</p-card>
